import { s as styleInject } from './style-inject.es-e7b07dd7.js';

var css_248z = ".M-IQw{direction:ltr}.ihbfC{direction:rtl}.qsl2L{background:transparent;border:none;cursor:pointer;display:flex;outline:none;padding-inline-end:14px;padding-inline-start:10px}.qsl2L:hover{opacity:.7}.ihbfC .qsl2L{transform:scaleX(-1)}.qJqTx{fill:#646464;color:#646464;outline:none;transition:transform .15s linear}.qJqTx._6wqon{transform:rotate(90deg)}._06ZiX{overflow-wrap:break-word;width:100%;word-break:break-word}";
var collapsibleListStyles = {"ltr":"M-IQw","rtl":"ihbfC","iconContainer":"qsl2L","icon":"qJqTx","isExpanded":"_6wqon","listDimensions":"_06ZiX"};
styleInject(css_248z);

export { collapsibleListStyles as c };
//# sourceMappingURL=collapsible-list-component.rtlignore-b2e49eb3.js.map
